module.exports = __webpack_public_path__ + "static/media/Avenir-HeavyOblique.4c984ad8.woff";